import { render, staticRenderFns } from "./FormCustomerLocation.vue?vue&type=template&id=5515d0ad"
import script from "./FormCustomerLocation.vue?vue&type=script&lang=js"
export * from "./FormCustomerLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormCustomerLocation.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5515d0ad')) {
      api.createRecord('5515d0ad', component.options)
    } else {
      api.reload('5515d0ad', component.options)
    }
    module.hot.accept("./FormCustomerLocation.vue?vue&type=template&id=5515d0ad", function () {
      api.rerender('5515d0ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/FormCustomerLocation.vue"
export default component.exports